import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import actions from './actions';

import ListaTarefasConfirmacaoView from './ListaTarefasConfirmacaoView';

class ListaTarefas extends Component {
  toggleRender = false;

  componentDidMount() {
    this.props.actions.onLoadTodasTarefasConfig();
  }

  render () {
    this.toggleRender = !this.toggleRender;
    return <ListaTarefasConfirmacaoView key={this.toggleRender} {...this.props} />
  }
}
let mapStateToProps = ({ agenda }) => ({
  value: agenda.config
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaTarefas);


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaTarefasConfirmacao.js